import { Link } from "react-router-dom";
import type { WorkItem } from "@/mocks/works";

export default function WorkCard({ item }: { item: WorkItem }) {
  return (
    <Link
      to={`/works/detail/${item.id}`}
      className="group block bg-background-50 border border-background-200 rounded-lg overflow-hidden hover:border-accent-400 transition-colors"
    >
      <div className="relative w-full aspect-[2/3] overflow-hidden bg-background-100">
        <img
          src={item.cover}
          alt={`${item.title} 海报`}
          title={`${item.title} - 白石茉莉奈作品`}
          className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
        />
        <span className="absolute top-3 left-3 text-[11px] font-body px-2.5 py-1 rounded-full bg-foreground-950/75 text-background-50 backdrop-blur">
          {item.type}
        </span>
        <span className="absolute top-3 right-3 text-[11px] font-body px-2.5 py-1 rounded-full bg-accent-500 text-foreground-950">
          {item.roleType}
        </span>
      </div>
      <div className="p-3.5 md:p-4">
        <h3 className="font-heading text-base text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
          {item.title}
        </h3>
        <div className="flex items-center justify-between mt-2">
          <span className="text-xs text-foreground-400 font-body">
            {item.year} · {item.meta.split(" · ")[1]}
          </span>
          <span className="text-xs font-body text-accent-700 flex items-center gap-1">
            <i className="ri-star-fill"></i>
            {item.rating.toFixed(1)}
          </span>
        </div>
        <p className="text-xs text-foreground-500 mt-2 font-body line-clamp-1">
          饰 {item.role}
        </p>
      </div>
    </Link>
  );
}